import { ReactNode, useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { ElementToPrint } from "./element";
import { PaperSize, PrintPage } from "./print-page";
import {
  PrintPreviewDialog,
  PrintPreviewDialogProps,
} from "./print-preview-dialog";
import { RowsElementProps } from "./rows-element";

type PreviewPrintingProps = PrintPreviewDialogProps & {
  fontSize?: string;
  paperSize: PaperSize;
  paperPadding?: string;
  mode?: "portrait" | "landscape";
  templateImage?: string;
  printIncludeTemplate?: boolean;
  elements?: ElementToPrint[] | ReactNode;
  rowsElement?: RowsElementProps;
  backgroundSize?: string;
  backgroundPosition?: string;
};

export const PreviewPrinting = ({
  fontSize,
  paperSize,
  paperPadding,
  elements = [],
  templateImage,
  mode,
  rowsElement,
  printIncludeTemplate = false,
  backgroundSize,
  backgroundPosition,
  ...props
}: PreviewPrintingProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef: printIncludeTemplate ? containerRef : contentRef,
    bodyClass: "",
  });
  const onPrintClicked = useCallback(() => {
    handlePrint();
  }, [handlePrint]);
  return (
    <PrintPreviewDialog
      {...props}
      PaperProps={{
        sx: {
          maxWidth: "none",
        },
      }}
      onPrintClicked={onPrintClicked}
    >
      <style type="text/css" media="print">
        {`
              body {
                  margin: 0; 
                  font-family: "Times New Roman", Times, serif;
              }
                  header,
                  footer,
                  nav {                  
                    display: none !important;
                  }
                 
                  @page {
                        size: ${paperSize?.width || 0} ${
                          paperSize?.height || 0
                        };
                        size: ${mode || undefined};
                        margin:0 !important;
                        }`}
      </style>

      <PrintPage
        fontSize={fontSize}
        paperSize={paperSize}
        paperPadding={paperPadding}
        elements={elements}
        templateImage={templateImage}
        rowsElement={rowsElement}
        backgroundSize={backgroundSize}
        backgroundPosition={backgroundPosition}
        containerRef={containerRef}
        contentRef={contentRef}
      />
    </PrintPreviewDialog>
  );
};
